// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VKBLOCMB_TU9mYasvUML .XR4s7EEOlh0Ar_hnQhby{justify-content:left;width:100%}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapBtn": `VKBLOCMB_TU9mYasvUML`,
	"btn": `XR4s7EEOlh0Ar_hnQhby`
};
export default ___CSS_LOADER_EXPORT___;
